import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { formatCurrency } from '../../utils/formatters';

const COLORS = ['#D4AF37', '#FFD700', '#B8860B', '#DAA520', '#F0E68C', '#EEE8AA'];

const RevenuePieChart = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <div className="h-4 w-40 bg-theme-tertiary rounded mb-4 animate-pulse"></div>
        <div className="h-64 bg-theme-tertiary rounded animate-pulse"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
                <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Revenue by Category</h3>        <div className="h-64 flex items-center justify-center text-theme-muted">
          <p>No revenue data available</p>
        </div>
      </div>
    );
  }

  const formattedData = data.map(item => ({
    name: item.category || 'Uncategorized',
    value: parseFloat(item.revenue || 0)
  })).filter(item => item.value > 0);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const total = formattedData.reduce((sum, item) => sum + item.value, 0);
      const percentage = ((payload[0].value / total) * 100).toFixed(1);

      return (
        <div className="bg-theme-secondary p-3 border border-theme rounded-lg shadow-theme-lg">
          <p className="text-sm font-medium text-theme-muted mb-1">{payload[0].name}</p>
          <p className="text-sm font-semibold text-accent-gold">
            {formatCurrency(payload[0].value)}
          </p>
          <p className="text-xs text-theme-muted">{percentage}% of total</p>
        </div>
      );
    }
    return null;
  };

  const CustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    if (percent < 0.05) return null;

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        fontSize={12}
        fontWeight="bold"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
              <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Revenue by Category</h3>      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={formattedData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={CustomLabel}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {formattedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend
            verticalAlign="bottom"
            height={36}
            wrapperStyle={{ fontSize: '12px', color: 'var(--color-text-primary)' }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenuePieChart;
